import {
	//  PayloadAction,
	createSlice,
} from "@reduxjs/toolkit";

interface QrState {
	loading: boolean;
	searchQuery: string;
}

const initialState: QrState = {
	loading: false,
	searchQuery: "",
};

const reducerAmigurumi = createSlice({
	name: "reducerAmigurumi",
	initialState,
	reducers: {
		setSearchQuery: (state, action) => {
			state.searchQuery = action.payload;
		},
		deleteSearchQuery: (state) => {
			state.searchQuery = "";
		},
	},
	extraReducers: (builder) => {},
});

export const { setSearchQuery } = reducerAmigurumi.actions;
export default reducerAmigurumi.reducer;
